import {
  B1,
  DeleteModal,
  getTranslatedText,
  H1,
  Loader
} from '@nile/components';
import { AccountClient, GET_UNKNOWN_EMAIL } from '@nile/graphql';
import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TaskViewContainer';
import { SVGIcon } from '@superops/super-icons';
import { Button, Sheet } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

const IconHolder = styled.div`
  cursor: pointer;
`;

const LoadWrapper = styled.div`
  height: 100vh;
  width: 600px;
`;

const MailWrapper = styled.div`
  padding: 12px;
  overflow: auto;
  height: 100vh;
  width: 40vw;
  background-color: #fff;
  .header {
    margin-bottom: 20px;
  }
  .subject {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .recepients {
    margin-bottom: 10px;
  }
`;
const CardSection = styled.div`
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 12px;
  margin-bottom: 20px;
`;

const Mail = styled.div`
  color: blue;
  font-weight: 500;
  margin-right: 50px;
`;

const Link = styled.div`
  color: #011fff;
  cursor: pointer;
`;

function HTMLCell(props) {
  const { cell, action, intl } = props;
  const meta = cell?.row?.original;
  const { actions } = cell.column;
  const value = cell.value;
  const template = cell.row.original;

  const [sheetActive, setSheetActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unknownEmail, setUnknownEmail] = useState(null);
  const unknownEmailId = cell?.row?.original?.unknownEmailId;
  const [isRead, setIsRead] = useState(meta.readStatus);

  const toggleSheetActive = async () => {
    setSheetActive(!sheetActive);
    setIsRead(true);
    actions.onClick(meta);
    setLoading(true);
    const response = await AccountClient.query({
      query: GET_UNKNOWN_EMAIL,
      variables: { unknownEmailId: unknownEmailId },
      fetchPolicy: 'network-only'
    });
    setUnknownEmail(response?.data?.getUnknownEmail);
    setLoading(false);
  };

  const closeSheet = () => {
    setSheetActive(!sheetActive);
  };

  /* revisit dangerouslySetInnerHTML xss  */

  const modalActivator = (
    <div className="mr-8">
      <Button>
        <IconHolder className="deleteItem">
          <SVGIcon name="Delete" />
        </IconHolder>
      </Button>
    </div>
  );

  const stopEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return value ? (
    <CellWrapper>
      <Link
        onClick={toggleSheetActive}
        className={`ellipsis ${!isRead ? 'bold' : ''}`}
      >
        {meta.subject}

        <Sheet open={sheetActive} onClose={closeSheet}>
          {loading ? (
            <LoadWrapper>
              <Loader />
            </LoadWrapper>
          ) : (
            <MailWrapper onClick={stopEvents}>
              <div className="flex actr mb-20">
                <H1>
                  <B1>
                    <FormattedMessage id="mail.unknown.email.title" />
                  </B1>
                </H1>
                <div className="fx2 flex jend actr">
                  <DeleteModal
                    modalActivator={modalActivator}
                    description={getTranslatedText(
                      intl,
                      'mail.unknown.delete.description'
                    )}
                    handleDeleteConfirmation={() =>
                      actions.onDelete(meta, closeSheet)
                    }
                    title={getTranslatedText(intl, 'mail.unknown.delete.title')}
                  />
                  {/* <ClientConversationModal
                  intl={intl}
                  actions={actions}
                  meta={meta}
                /> */}
                  <Button plain onClick={closeSheet}>
                    <FormattedMessage id="common.close" />
                  </Button>
                </div>
              </div>
              <CardSection>
                <B1 className="subject">{unknownEmail?.subject}</B1>
                <div className="flex recepients">
                  <Mail>
                    <FormattedMessage id="mail.unknown.from.label" />
                  </Mail>
                  <div>{unknownEmail?.fromAddress}</div>
                </div>
                {/* <div className='flex'>
                <Mail>CC</Mail>
                <div>{tempate.fromAddress}</div>
              </div> */}
                {unknownEmail?.meta ? (
                  unknownEmail?.meta?.htmlContent ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: unknownEmail?.meta?.htmlContent
                      }}
                    ></p>
                  ) : unknownEmail?.meta?.textContent ? (
                    unknownEmail?.meta?.textContent
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
              </CardSection>
            </MailWrapper>
          )}
        </Sheet>
      </Link>
    </CellWrapper>
  ) : (
    <DisabledTag>
      <FormattedMessage id="app.noData.message" />
    </DisabledTag>
  );
}

export default injectIntl(HTMLCell);
